import React from 'react';
import { Typography, /* Rating */ Tooltip, Stack } from '@mui/material';
// import StarBorder from '@mui/icons-material/StarBorder';
// import StarIcon from '@mui/icons-material/Star';
import { createNewDate, culture, options } from '../../../Helpers/dates';
import {
  CenteredFlexBox,
  ColumnFlexBox /* FlexBox */,
} from '../../../Components/FlexBox';
import PersonOffRoundedIcon from '@mui/icons-material/PersonOffRounded';
import capitalize from '../../../Helpers/StringsFormatting/capitalize';
import PlaylistAddCheckOutlinedIcon from '@mui/icons-material/PlaylistAddCheckOutlined';
import Chip from '../../Chip';

export default (userBranches, selectedBranch) => [
  {
    id: 'otherSections',
    noCaption: true,
    size: { md: 0.3 },
    formatCallback: (value) =>
      value ? (
        <Tooltip
          title={
            <ul>
              {value.split(',').map((el) => (
                <li key={el} style={{ fontSize: '1rem' }}>
                  {el}
                </li>
              ))}
            </ul>
          }
          placement="top"
          arrow
        >
          <PlaylistAddCheckOutlinedIcon sx={{ opacity: 0.6 }} />
        </Tooltip>
      ) : (
        <div />
      ),
  },

  {
    id: 'fullName',
    noCaption: true,
    formatCallback: (value, data, translate) => (
      <ColumnFlexBox gap="6px">
        <Stack direction="row" spacing={1}>
          {data?.activeCampaigns.map(({ description }) => (
            <Chip
              key={description}
              label={description}
              color="transparent"
              height="unset"
            />
          ))}
        </Stack>
        <CenteredFlexBox gap="4px">
          {data?.removedOn && (
            <Tooltip
              placement="top"
              slotProps={{
                tooltip: { sx: { fontSize: '1rem', padding: '8px' } },
              }}
              title={`${translate('NEVER_CALL_AGAIN_AGAIN')} ${new Date(data?.removedOn)?.toLocaleDateString(culture, options)}`}
              arrow
            >
              <PersonOffRoundedIcon sx={{ color: 'error.main' }} />
            </Tooltip>
          )}
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            {capitalize(value)}
          </Typography>
        </CenteredFlexBox>
        {/* <FlexBox display="flex" gap="6px">
          <Rating
            name="read-only"
            value={parseInt(data?.ratingValue, 10) || 0}
            precision={1}
            readOnly
            emptyIcon={
              <StarBorder fontSize="inherit" sx={{ color: 'primary.main' }} />
            }
            icon={
              <StarIcon fontSize="inherit" sx={{ color: 'primary.main' }} />
            }
          />
          <Typography
            variant="body1"
            sx={{ fontSize: '1.2rem', fontWeight: 500 }}
            noWrap
          >
            {parseInt(data?.ratingValue, 10) || '0'}
          </Typography>
        </FlexBox> */}
      </ColumnFlexBox>
    ),
  },
  {
    id: 'mobilePhoneNumber',
    formatCallback: (value) =>
      userBranches.length > 1 && selectedBranch && value ? (
        <a
          style={{
            color: 'inherit',
            fontFamily: 'Roboto',
            fontWeight: 600,
            fontSize: '0.95rem',
            letterSpacing: '0.02em',
            textDecoration: 'none',
          }}
          href={`tel:${selectedBranch.prefix3CX}${value.replace('+39', '')}`}
        >
          {value}
        </a>
      ) : (
        value
      ),
  },
  {
    id: 'fiscalCode',
  },
  {
    id: 'birthDate',
    label: 'BIRTH_DATE',
    formatCallback: (value) =>
      `${createNewDate(value).toLocaleDateString(culture, options)}`,
  },
  ...(localStorage.getItem('employeer') !== 'undefined' &&
  localStorage.getItem('employeer') !== 'null' &&
  localStorage.getItem('employeer')
    ? [
        {
          id: 'employeer',
          label: 'EMPLOYER',
        },
      ]
    : []),
];
